import { Outlet, Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Resizable } from "re-resizable";
import * as API from "../services/pacientes";
import { ReactComponent as Logo } from "../img/logo.svg";
import Navigation from '../components/Navigation';

export function PacienteList(props) {
  const location = useLocation();
  const [pacienteList, setPacienteList] = useState();
  const [pacienteQuery, setPacienteQuery] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props.userRole.includes('administrador') || props.userRole.includes('psicologia-hospital') || props.userRole.includes('medicina')) {
          await API.getSearchPacientes(pacienteQuery).then(
            (val) => {
              console.log(val);
              setPacienteList(val);
            },
            (error) => {
              console.log(error);
            }
          );
        } else {
          await API.getSearchPacientesByEspecialista(pacienteQuery, props.especialistaId).then(
            (val) => {
              setPacienteList(val);
            },
            (error) => {
              console.log(error);
            }
          );
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [pacienteQuery]);
  return (
    <>
      <Resizable
        id='sidebar'
        defaultSize={{
          width: 315,
        }}
        minHeight='100vh'
        maxHeight='100vh'
      >
        <div className='logo'>
          <Logo />
        </div>

        <nav>
          <div id='formNewElement'>
            <div className='field'>
              <label htmlFor='pacienteQuery'>Buscar Paciente</label>

              <div className='control'>
                <input
                  className='input'
                  id='pacienteQuery'
                  required
                  type='text'
                  value={pacienteQuery}
                  onChange={(e) => setPacienteQuery(e.target.value)}
                />
              </div>
            </div>

            {pacienteList?.length ? (
              <ul>
                {pacienteList?.map((paciente) => (
                  <li key={paciente.id}>
                    <Link to={`${paciente.id}`}>
                    {paciente.display_name}
                    </Link>
                  </li>
                ))}
              </ul>
            ) : (
              <p>
                <i>Sin pacientes</i>
              </p>
            )}
          </div>
        </nav>

        {/* other code */}
      </Resizable>
      <main id='main'>
        <Navigation {...props} currentUrl={location.pathname} />
        <div id='detail'>
          <Outlet />
        </div>
      </main>
    </>
  );
}
